module.exports = __webpack_public_path__ + "img/weal_4.dfa192f7.jpg";